import React, { useCallback, useMemo } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { pageErrorPng } from '../../assets/images';
import { DefaultHeader } from '../../components/DefaultHeader';
import { SITE_LINKS } from '../../constants';
import { Background } from '../../stories/Background';
import { Button } from '../../stories/Button';

enum EndOfLevelErrors {
  EOL_ALREADY_APPROVED = 'EOL_ALREADY_APPROVED',
  EOL_CANNOT_RETAKE = 'EOL_CANNOT_RETAKE',
  UNKNOW = 'UNKNOW',
}

export interface EndOfLevelTestPageProps {
  data?: {
    status?: 'success' | 'error';
    lernosityUrl?: string;
    data?: {
      code?: EndOfLevelErrors;
      position?: number;
      wait_time_minutes?: number;
      wait_until?: string;
    };
  };
}

export const EndOfLevelTestPage: React.FC<EndOfLevelTestPageProps> = ({ data }) => {
  const __ = useTranslation().t;
  const waitTimeHour = Math.round((data?.data?.wait_time_minutes || 0) / 60);

  const errorMessages = useMemo(
    () => ({
      [EndOfLevelErrors.EOL_ALREADY_APPROVED]: __('completedEndOfLevelTest'),
      [EndOfLevelErrors.EOL_CANNOT_RETAKE]: __('waitTimeToTryAgainReviewLessons', { waitTimeHour }),
      [EndOfLevelErrors.UNKNOW]: __('teamWorkingOnIssue'),
    }),
    [data],
  );

  const errorTitles = useMemo(
    () => ({
      [EndOfLevelErrors.EOL_ALREADY_APPROVED]: __('congratulationsExclamation'),
      [EndOfLevelErrors.EOL_CANNOT_RETAKE]: __('somethingWentWrong'),
      [EndOfLevelErrors.UNKNOW]: __('somethingWentWrong'),
    }),
    [data],
  );

  const Content = useCallback(() => {
    const lernosityUrl = data?.lernosityUrl;

    if (lernosityUrl) {
      return <iframe title="End Of Level" src={lernosityUrl} />;
    }

    const errorCode = data?.data?.code ?? EndOfLevelErrors.UNKNOW;

    return (
      <Background className="oejr-page-end-of-level-error-container">
        <Container>
          <Row>
            <Col sm={12} md={6} className="text-center">
              <img src={pageErrorPng} alt="Error" />
            </Col>
            <Col sm={12} md={6} className="oejr-page-end-of-level-error-content">
              <h1>{errorTitles[errorCode]}</h1>
              <p>{errorMessages[errorCode]}</p>
              <Button
                label={__('home')}
                href={SITE_LINKS.HomePage}
                className="oejr-page-end-of-level-button"
              />
            </Col>
          </Row>
        </Container>
      </Background>
    );
  }, [data, errorMessages, errorTitles]);

  return (
    <div className="oejr-page-end-of-level-test">
      <DefaultHeader />
      <Content />
    </div>
  );
};
